import React, { useEffect, useState } from "react";
import { apiUrl } from "../config/config";
import OrderModal from "./OrderModal";
import SEO from "./SEO";

const getUserId = () => {
  const user = localStorage.getItem("user");
  if (!user) return null;
  try {
    const parsed = JSON.parse(user);
    return parsed?.id || null;
  } catch {
    return null;
  }
};

const Account = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOrder, setModalOrder] = useState(null);

  useEffect(() => {
    const userId = getUserId();
    if (!userId) {
      setLoading(false);
      return;
    }

    fetch(`${apiUrl}/api/orders/user/${userId}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) setOrders(data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Fetch orders error:", err);
        setLoading(false);
      });
  }, []);

  if (loading) return <p className="p-10 text-center">Loading orders...</p>;

  return (
    <>
          <SEO
                    title='My Account'
                    description='Blank Beanies'
                    keywords='Blank Beanies'
                  />
    <div className="mx-5 sm:mx-16 my-10">
      <h2 className="text-3xl font-semibold mb-6">My Orders</h2>

      {orders.length === 0 ? (
        <p>No orders found.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full border text-left text-gray-600">
            <thead className="bg-gray-50 font-semibold">
              <tr>
                <th className="px-4 py-2">Order ID</th>
                <th className="px-4 py-2">Name</th>
                <th className="px-4 py-2">Total</th>
                <th className="px-4 py-2">Status</th>
                <th className="px-4 py-2">Date</th>
                <th className="px-4 py-2">Actions</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((order) => (
                <tr key={order.id} className="border-b">
                  <td className="px-4 py-2">{order.id}</td>
                  <td className="px-4 py-2">
                    {order.first_name} {order.last_name}
                  </td>
                  <td className="px-4 py-2">${order.total}</td>
                  <td className="px-4 py-2">{order.payment_status}</td>
                  <td className="px-4 py-2">
                    {new Date(order.created_at).toLocaleString()}
                  </td>
                  <td className="px-4 py-2">
                    <button
                      className="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700"
                      onClick={() => setModalOrder(order)}
                    >
                      Preview
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Modal */}
      {modalOrder && (
        <OrderModal order={modalOrder} onClose={() => setModalOrder(null)} />
      )}
    </div>
    </>
  );
};

export default Account;
